import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import userManagementRouteList from "./routeList";
import PrivateRoute from "../../Authentication/component/PrivateRoute";
import Loader from "../../utilis/component/SkeletonLoading/Loader";
const MenuRearrange = lazy(()=>import("./MenuArrange"));
const AddOrEditMenu = lazy(()=>import("./Menu/AddOrEditMenu"));
const MenuSettings = lazy(() => import("./Menu"));
const UserPrivilages = lazy(() => import("./UserPrivilages"));
const LogHistory = lazy(() => import("./LogHistory/index"));
const UserLog = lazy(() => import("./UserLog"));

const userManagementRoutes: RouteObject[] = [
  {
    path: userManagementRouteList.userPrivilage,
    element: (
      <PrivateRoute>
        <Loader>
          <UserPrivilages />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: userManagementRouteList.menuSetting,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <MenuSettings />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: userManagementRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditMenu />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: userManagementRouteList.LogHistory,
    children: [{
      path:"",
      element:(
      <PrivateRoute>
        <Loader>
          <LogHistory />
        </Loader>
      </PrivateRoute>
    )}],
  },
  {
    path: userManagementRouteList.userLog,
    children: [{
      path:"",
      element:(
      <PrivateRoute>
        <Loader>
          <UserLog />
        </Loader>
      </PrivateRoute>
    )}],
  },
  {
    path: userManagementRouteList.menuRearragne,
    children: [{
      path:"",
      element:(
      <PrivateRoute>
        <Loader>
          <MenuRearrange />
        </Loader>
      </PrivateRoute>
    )}],
  },

];

export default userManagementRoutes;
